import constants from "../../../constants";
import { getDataFromStorage } from "../../../util";
import AlertContext from "../../../context/AlertContext";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import { SandpackProvider } from "@codesandbox/sandpack-react";
import Loading from "../../Notification-Loading/Loading/Loading";
import React, { memo, useContext, useEffect, useRef } from "react";
import "../../utils/sandpackEditor.css";
import SandpackReactEditorTools from "./SandpackReactEditorTools";
import SandpackAssignment from "./SandpackAssignment";
import ModuleHooks from "../../../Hooks/ModuleHooks";
import RecommendedWebsites from "./RecommendedWebsites";
import SandPackEditorHooks from "../../../Hooks/SandPackEditorHooks";
export default memo(function SandpackReactEditor(Props) {
  const {
    isLoaded,
    lpConfigId,
    isFullScreensp,
    openSandpackEditor,
    setOpenSandpackEditor,
    navigate,
    isAdmin,
    testData,allWindowsBlurred, showInstructions,
    setShowInstructions,assignmentTestData,openRecommendedList
  } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const focusOutTimer = useRef(null);
  const focusOutSec = useRef(0);
  const { electronAPI } = window;
  const SandPackEditorHks = SandPackEditorHooks();
  
  const currentDueLabel = (date) => {
    console.log("date",date);
    const dueDate = new Date(date);
    const currentDate = new Date();

    const timeDifference = dueDate.getTime() - currentDate.getTime();
    const dayDifference = Math.floor(timeDifference / (1000 * 3600 * 24));

    if (dayDifference === 0) {
      return "Due Today";
    } else if (
      dayDifference === 1 ||
      (dayDifference === 0 && dueDate !== currentDate)
    ) {
      return "Due Tomorrow";
    } else if (dayDifference < 0) {
      return "Past Due";
    } else {
      return "Upcoming";
    }
  };

  const onFocus = () => {
    if (!allWindowsBlurred.current || !electronAPI) {
      focusOutSec.current = 0;
    }
    if(!electronAPI){
      clearInterval(focusOutTimer.current);
    }
    if(electronAPI){
    allWindowsBlurred.current = false;
    }
    window.removeEventListener("blur", onBlur);
  };



  const onBlur = () => {
    // console.log("allWindowsBlurred in sandpackEditor",allWindowsBlurred.current);
    focusOutTimer.current = setInterval(() => {
      let second = focusOutSec.current;
      if (second === 10 ) {
        // console.log("ready to submit---->");
        clearInterval(focusOutTimer.current);
        SandPackEditorHks.closeAssignment();
      } else if(allWindowsBlurred.current || !electronAPI) {
        second++;
        // console.log("second->",second);
        focusOutSec.current = second;
      }
    }, 1000);
  };

  useEffect(() => {
    if (!isAdmin && Props.status !== constants.PROGRESS_STATUS.EVALUATED && testData.proctored !==constants.PROCTORING_MODE.NONE
      && (currentDueLabel(testData.duedate) !== "Past Due" || localStorage.getItem("batchType")== constants.BATCH_TYPE.SELF) 
    ) {
      window.addEventListener("blur", onBlur);
      window.addEventListener("focus", onFocus);
      return () => {
        window.removeEventListener("blur", onBlur);
        window.removeEventListener("focus", onFocus);
        clearInterval(focusOutTimer.current);
      };
    }
  }, [onBlur]);

  // useEffect(() => {
  //   console.log("isTakeTest", isTakeTest);
  //   if (document.documentElement.requestFullscreen) {
  //     document.documentElement.requestFullscreen();
  //   } else if (document.documentElement.mozRequestFullScreen) {
  //     document.documentElement.mozRequestFullScreen();
  //   } else if (document.documentElement.webkitRequestFullscreen) {
  //     document.documentElement.webkitRequestFullscreen();
  //   } else if (document.documentElement.msRequestFullscreen) {
  //     document.documentElement.msRequestFullscreen();
  //   }
  //   return () => {
  //     if (document.fullscreenElement) {
  //       document.exitFullscreen();
  //     } else if (document.mozFullScreenElement) {
  //       document.mozCancelFullScreen();
  //     } else if (document.webkitFullscreenElement) {
  //       document.webkitExitFullscreen();
  //     } else if (document.msFullscreenElement) {
  //       document.msExitFullscreen();
  //     }
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleFullscreenChange = () => {
  //     if (!document.fullscreenElement) {
  //       console.log("Exited fullscreen mode");
  //       if (isAdmin) {
  //         navigate("/assignment");
  //       } else {
  //         console.log("closing.........");
  //         if (Props.status !== constants.PROGRESS_STATUS.EVALUATED) {
  //           closeAssignment();
  //         } else {
  //           navigate("/home");
  //         }
  //       }
  //     } else {
  //       console.log("Entered fullscreen mode");
  //     }
  //   };
  //   // Attach the fullscreen change event listener
  //   document.addEventListener("fullscreenchange", handleFullscreenChange);
  //   // Cleanup event listener when component unmounts
  //   return () => {
  //     document.removeEventListener("fullscreenchange", handleFullscreenChange);
  //   };
  // }, []);

  // useEffect(() => {

  //   const handleFullscreenChange = () => {
  //     if (!document.fullscreenElement && (allWindowsBlurred.current || !electronAPI)) {
  //       console.log("Exited fullscreen mode");
  //       if (isAdmin) {
  //         navigate("/assignment");
  //       } else {
  //         console.log("closing.........");
  //         console.log("Props:",Props);
  //         if (Props.status !== constants.PROGRESS_STATUS.EVALUATED && (currentDueLabel(testData.duedate) !== "Past Due" || localStorage.getItem("batchType")== constants.BATCH_TYPE.SELF) && testData.proctored!==constants.PROCTORING_MODE.NONE) {
  //           console.log("Closing Assignments..");
  //           SandPackEditorHks.closeAssignment();
  //         } else {
  //           navigate("/home");
  //         }
  //       }
  //     }
  //   };
    
  //   document.addEventListener("fullscreenchange", handleFullscreenChange);
  //   return () => {
  //     document.removeEventListener("fullscreenchange", handleFullscreenChange);
  //   };
  // }, []);

  useEffect(() => {
    // When component mounts
    let role = getDataFromStorage("role");

    if (
      role === constants.Roles.learner &&
      ![
        constants.PROGRESS_STATUS.SUBMITTED &&
          constants.PROGRESS_STATUS.TO_BE_EVALUATED,
    ].includes(Props.status) && (allWindowsBlurred.current || !electronAPI)
    ) {
      const newStartTime = Date.now();

      let storedTime;
      let learnerId = getDataFromStorage("learnerid");

      async function duration() {
        // storedTime = localStorage.getItem('timeSpent');

        let response = await axios.get(
          `node/learner/content/timespent/${learnerId}/${lpConfigId}`,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );

        storedTime = response?.data?.data?.duration;
        storedTime = storedTime * 1000 * 60;
      }

      duration();

      // When component unmounts

      return () => {
        async function save() {
          const endTime = Date.now();

          let timeSpent =
            endTime - newStartTime + (storedTime ? storedTime : 0);
          timeSpent = Math.round(timeSpent / (60 * 1000));

          let learnerId = getDataFromStorage("learnerid");
          let requestData = {
            duration: timeSpent,
            learnerid: learnerId,
            lpconfigid: lpConfigId,
          };

          // localStorage.setItem('timeSpent', timeSpent.toString());

          await axios.post(`node/learner/content/timespent`, requestData, {
            headers: {
              "Content-Type": "application/json",
            },
          });
        }
        if (
          role === constants.Roles.learner &&
          ![
            constants.PROGRESS_STATUS.SUBMITTED &&
              constants.PROGRESS_STATUS.TO_BE_EVALUATED,
        ].includes(Props.status) && (allWindowsBlurred.current || !electronAPI)
        ){
        save();
        }
      };
      
    }
  }, []);

  return (
    <div
      className={
        isFullScreensp ? "sandpackEditorContainer1" : "sandpackEditorContainer2"
      }
    >
         {openRecommendedList && (
        <div className="recommendedwebsitescont">
          <RecommendedWebsites />
        </div>
      )}
      {
        <div className="recommendedwebsitescont">
          <SandpackAssignment
            showAssignmentInstructions={showInstructions}
            setShowAssignmentInstructions={setShowInstructions}
            description={assignmentTestData.description}
            name={testData.libname}
            
          />
        </div>
      }
      {/* {!isAdmin && Props.status !== constants.PROGRESS_STATUS.EVALUATED && testData.proctored == constants.PROCTORING_MODE.TAB_CAM && (
        <Profile
          isTakeTest={isTakeTest}
          questionid={testData.libid}
          libtypeid={constants.libTypeIds.ASSIGNMENT}
        />
      )} */}

      {isLoaded && <Loading />}
      <SandpackProvider
        template={Props.selectedTemplate?.value?.toLowerCase() ?? "react"}
        options={{
          autorun: true,
          autoReload: true,
          showConsole: true,
          showConsoleButton: true,
          // autorun: false,
          // autoReload: false,
          // showConsole: false, 
        }}
      >
        <SandpackReactEditorTools
          status={Props.status}
          focusOutSec={focusOutSec}
          learnerId={Props.learnerId}
          libDetails={Props.libDetails}
          isqueReport={Props.isqueReport}
          template={Props.selectedTemplate}
          isAddSubmission={Props.isAddSubmission}
          openSandpackEditor={openSandpackEditor}
          setOpenSandpackEditor={setOpenSandpackEditor}
        />
      </SandpackProvider>
    </div>
  );
});
